module.exports = __webpack_public_path__ + "img/df-logo.05acbf93.png";